const FP_PROMO_MAIN_TYPE = 'fp_promo_25';

export {
    FP_PROMO_MAIN_TYPE
};
